import { Button, Form, message, UploadFile } from "antd";
import React, { useEffect, useState } from "react";
import SinglePageContainer from "../../../Common/SinglePageContainer";
import UsersForm, { UserFormValues } from "../Form";
import { useTranslation } from "react-i18next";
import { useBreadcrumbs } from "../../../../context/breadcrumbs";
import { HomeOutlined } from "@ant-design/icons";
import {
  UserCreateParams,
  UserUpsetParams,
  useUserCreate,
} from "../../../../hooks/api/users";
import { useNavigate } from "react-router";
import { useMessageError, useMessageSuccess } from "../../../../hooks/common";

export default function UsersCreateContent(): React.ReactNode | null {
  const navigate = useNavigate();
  const [form] = Form.useForm<UserFormValues>();
  const { t, i18n } = useTranslation();
  const { setBreadcrumbs } = useBreadcrumbs();
  const userCreate = useUserCreate();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    setBreadcrumbs([
      { title: <HomeOutlined />, href: "/" },
      { title: "Managers", href: "/users" },
      { title: t("common.create") },
    ]);
  }, [i18n.language, t]);

  const sendInvitation = async () => {
    try {
      await form.validateFields();
      message.success(t("pages.users.invitationSent"));
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (values: UserUpsetParams) => {
    const avatarUrl = fileList[0]?.url || "";
    const payload = {
      ...values,
      // avatar: avatarUrl,
      // zipCode: values.zipCode ?? "",
    };
    try {
      await userCreate.fetch(payload).then((res) => {
        if (res?.email) {
          message.success("Manager added");
          navigate(`/users/`);
        }
      });
    } catch (error: any) {
      message.error(error?.message);
    }
  };

  useMessageError([userCreate]);

  return (
    <SinglePageContainer
      title="Add manager"
      extra={
        <>
          <Button type="primary" onClick={() => form.submit()}>
            Save & send invitation
          </Button>
        </>
      }
    >
      <div>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <UsersForm fileList={fileList} setFileList={setFileList} />
        </Form>
      </div>
    </SinglePageContainer>
  );
}
